const COOKIE_NAME = "popin-newsletter-dismissed";
const COOKIE_DURATION_MINUTES = 1440;
const DELAY_MS = 8000;

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(initPopin, DELAY_MS);
});

/**
 * Initializes the popin logic:
 * - Checks for required DOM elements
 * - Parses JSON data
 * - Creates and inserts the popin
 * - Binds events
 */
function initPopin() {
  const page = document.querySelector(".main");
  const dataScript = document.getElementById("popin-data");

  if (!page || !dataScript) return;
  if (document.cookie.includes(`${COOKIE_NAME}=true`)) return;

  let data;
  try {
    data = JSON.parse(dataScript.textContent);
  } catch (e) {
    console.error("Error parsing JSON for popin:", e);
    return;
  }

  const popin = createPopin(data);
  page.insertBefore(popin, page.firstChild);
  document.body.style.overflow = 'hidden';

  bindPopinEvents(popin);
}

/**
 * Creates the popin DOM structure.
 *
 * @param {Object} data - Data used to populate the popin.
 * @param {Object} data.image - Image object with `src` and `alt`.
 * @param {string} data.title - Title text.
 * @param {string} data.description - Description text.
 * @param {string[]} data.buttons - Array of button labels.
 * @param {string} data.disclaimer - Disclaimer text.
 * @returns {HTMLElement} The constructed popin element.
 */
function createPopin(data) {
  const popin = document.createElement("div");
  popin.className = "popin";

  const container = document.createElement("div");
  container.className = "popin__container";

  const media = document.createElement("div");
  media.className = "popin__media";

  const img = document.createElement("img");
  img.className = "popin__image x-width-100 x-height-100 x-fit-cover";
  img.src = data.image?.src || "";
  img.alt = data.image?.alt || "";

  media.appendChild(img);

  const content = document.createElement("div");
  content.className = "popin__content";

  const title = document.createElement("p");
  title.className = "popin__title heading-01 mb-12 x-upper";
  title.innerHTML = data.title || "";

  const description = document.createElement("p");
  description.className = "popin__description body-03 mb-12";
  description.innerHTML = data.description || "";

  const actions = createButtons(data.buttons || []);

  // const disclaimer = document.createElement("p");
  // disclaimer.className = "popin__disclaimer caption-02";
  // disclaimer.innerHTML = data.disclaimer || "";

  content.appendChild(title);
  content.appendChild(description);
  content.appendChild(actions);
  // content.appendChild(disclaimer);

  const closeButton = createCloseButton();

  container.appendChild(media);
  container.appendChild(content);
  container.appendChild(closeButton);
  popin.appendChild(container);

  return popin;
}

/**
 * Creates the action buttons for the popin.
 *
 * @param {string[]} labels - Array of button labels.
 * @returns {HTMLElement} The container with buttons.
 */
function createButtons(labels) {
  const actions = document.createElement("div");
  actions.className = "popin__actions";

  const buttonClasses = [
    "button -large -primary -black",
    "button -large -primary -white"
  ];

  labels.forEach((label, index) => {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = buttonClasses[index] || "button";
    btn.textContent = label;
    actions.appendChild(btn);
  });

  return actions;
}

/**
 * Creates the close button element.
 *
 * @returns {HTMLElement} The close button.
 */
function createCloseButton() {
  const closeButton = document.createElement("button");
  closeButton.className = "popin__close-button";
  closeButton.setAttribute("aria-label", "Close popin");

  const iconClose = document.createElement("span");
  iconClose.className = "icon-close";
  closeButton.appendChild(iconClose);

  return closeButton;
}

/**
 * Binds click events to the popin buttons.
 *
 * @param {HTMLElement} popin - The popin element.
 */
function bindPopinEvents(popin) {
  const buttons = popin.querySelectorAll(".popin__actions button");
  const closeButton = popin.querySelector(".popin__close-button");

  if (closeButton) {
    closeButton.addEventListener("click", () => closePopin(popin));
  }

  if (buttons[1]) {
    buttons[1].addEventListener("click", () => closePopin(popin));
  }

  if (buttons[0]) {
    buttons[0].addEventListener("click", () => {
      closePopin(popin);
      showNewsletter();
    });
  }
}

/**
 * Closes the popin and sets a dismissal cookie.
 *
 * @param {HTMLElement} popin - The popin element to hide.
 */
function closePopin(popin) {
  popin.style.display = "none";
  setCookie(COOKIE_NAME, "true", COOKIE_DURATION_MINUTES);
  document.body.style.overflow = '';
}

/**
 * Scrolls to the newsletter section and highlights it.
 */
function showNewsletter() {
  const newsletter = document.querySelector(".newsletterWrapper");
  if (!newsletter) return;

  newsletter.scrollIntoView({ behavior: "smooth", block: "center" });
  newsletter.classList.add("highlighted");

  const stopPulse = () => {
    newsletter.classList.remove("highlighted");
    newsletter.removeEventListener("click", stopPulse);
    newsletter.removeEventListener("focusin", stopPulse);
  };

  newsletter.addEventListener("click", stopPulse);
  newsletter.addEventListener("focusin", stopPulse);
}

/**
 * Sets a cookie with a specific expiration time.
 *
 * @param {string} name - The name of the cookie.
 * @param {string} value - The value to store.
 * @param {number} minutes - Expiration time in minutes.
 */
function setCookie(name, value, minutes) {
  const expires = new Date();
  expires.setTime(expires.getTime() + minutes * 60 * 1000);
  document.cookie = `${name}=${value}; path=/; expires=${expires.toUTCString()}`;
}
